module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "zk-alert-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "zk-alert",
    class: [_vm.typeClass]
  }, [(_vm.showIcon) ? _c('i', {
    staticClass: "zk-alert__icon",
    class: [_vm.iconClass, _vm.isBigIcon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zk-alert__content"
  }, [(_vm.title) ? _c('span', {
    staticClass: "zk-alert__title",
    class: [_vm.isBoldTitle]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "zk-alert__description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closable),
      expression: "closable"
    }],
    staticClass: "zk-alert__closebtn",
    class: {
      'is-customed': _vm.closeText !== '', 'zk-icon-close': _vm.closeText === ''
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.closeText))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-44405803"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/alert/src/alert.vue
// module id = 252
// module chunks = 0